export enum INFO_TYPE {
    DOCUMENT = "documents",
    SERVICE_HISTORY = "service_history"
}